import React from 'react';

const SmallErrorText = ({text, style}) => <span style={{...style, fontSize: '12px', color: '#912d2b'}} >*{text}</span>;

export default SmallErrorText;